import {
  // Avatar, Button,
  Card, CardContent, Typography, Stack, Chip, Box, Grid, styled,
  // CardActions, CardMedia
} from '@mui/material';
import Link from 'next/link';
// import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
// import { readingTime } from '../../utils/helpers';
import { getRandomStr } from '../../helpers';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { useState } from 'react';

const StyledCard = styled(Card)`
  cursor: pointer;
  overflow: hidden;
  img { transition: transform 300ms ease-in-out; background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.9)); }
  &:hover img { transform: scale(1.02); }`;

export default function Idea({ post, index }) {
  const router = useRouter()
  const [more, setMore] = useState(false);

  const convertTime12to24 = time12h => {
    const [time, modifier] = time12h?.split(' ');
    let [hours, minutes, seconds] = time ? time.split(':') : null;
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  };

  const getDate = (date) => {
    let d = new Date(date);
    let n = d.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
    let t = d.toLocaleTimeString('en-US', { timeZone: "America/New_York" })
    let replase = n?.replace(new RegExp(',', 'g'), ' ')
    return `${replase} • ${convertTime12to24(t)}`
  }

  const isDateWithinLastFiveDays = (dateString) => {
    const inputDate = new Date(dateString);
    const currentDate = new Date();

    // Calculate the difference in time
    const timeDifference = currentDate - inputDate;

    // Convert time difference from milliseconds to days
    const differenceInDays = timeDifference / (1000 * 60 * 60 * 24);

    return differenceInDays <= 5;
  }

  return (
    <>
      {/* <Grid size={{ md: 6, xs: 12, sm: 6 }}> */}
      <StyledCard key={index} className={post?.frontmatter?.tags?.find(d => d === 'premium') ? 'premium-blog' : 'blog'}
        onClick={() => router.push(`/stock-ideas/${post.slug}`)}
        sx={{
          // maxWidth: 650,
          // height: '100%',
          // '&:hover': { background: 'fbfbfc', boxShadow: '0 3px 5px rgba(132,135,154,.2), 0 1px 1px rgba(132,135,154,.2)' },
          border: '1px solid #b3cbd936', m: '0 !important',
          cursor: 'pointer', p: '12pxx', borderRadius: '8px', boxShadow: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
          // bgcolor: (post?.frontmatter?.tags?.find(d => d === 'premium') || (index === 0 || index === 1)) ? '#f8f9fa' : 'transparent'
          img: { objectFit: "cover", height: "17rem !important" }
        }}>
        {post?.frontmatter?.cover_image &&
          <Image
            src={post?.frontmatter?.cover_image}
            alt={post?.frontmatter?.title}
            layout="responsive"
            objectFit="cover"
            quality={47}
            height={57}
            width={100}
            blurDataURL="URL"
            placeholder="blur"
            objectPosition="top"
          />}
        <CardContent sx={{ px: { xs: 2, md: '24px', sm: '24px' }, pt: '24px', height: '100%' }}>
          {/* <Stack direction="row" spacing={1}>
            {post?.frontmatter?.tags?.map(d =>
              d && d === 'premium' ?
                <Chip key={getRandomStr(3)} label={d} size="small" sx={{ background: 'linear-gradient(to right, #2DA1EE, #174ea6)', color: '#fff', textTransform: 'capitalize' }} /> :
                <Chip key={getRandomStr(3)} label={d.replace(/-/g, " ")} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', textTransform: 'capitalize' }} />)}
            {(index == 0 || index == 1) && !post?.frontmatter?.tags?.find(d => d === 'latest') && <Chip label={`Latest`} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', }} />}
          </Stack> */}
          <Typography variant="h6" component="div" sx={{ fontWeight: 600, fontSize: '1.5rem', '& a': { color: '#1d1d1f', textDecoration: 'none' }, '& a:hover': { color: '#174ea6', textDecoration: 'underline' }, lineHeight: 1.2, }}>
            <Link href={`/stock-ideas/${post.slug}`}>
              {post?.frontmatter?.title}
            </Link>
          </Typography>
          <Box component="div" sx={{ mx: 0, my: 1, flexGrow: 1, display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
            {/* <CardActions sx={{ px: { xs: 2, sm: 3, md: 3 }, pb: 3 }}> */}
            <Typography variant="caption" sx={{ fontSize: '.8rem', fontWeight: 500, mr: 2 }} color="#444"> {/* #6e6e73 */}
              Last Updated: {getDate(post?.frontmatter?.date)}
            </Typography>
            {/* <Button href={`/stock-ideas/${post.slug}`} size="small" endIcon={<KeyboardArrowRightRoundedIcon fontSize="small" />} sx={{ textTransform: 'none', ml: 'auto', fontSize: '.8rem', fontWeight: 600 }}>Read more</Button> */}
            {/* </CardActions> */}
            {isDateWithinLastFiveDays(post?.frontmatter?.date) && post?.frontmatter?.latest ?
              <Chip label={`Latest`} size="small" sx={{ background: '#E7EBF0', color: '#174ea6', border: 1, borderColor: '#3E50602c' }} /> : null}
          </Box>
          <Typography variant="body1"
            sx={{
              fontSize: '.97rem', display: '-webkit-box',
              WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis',
            }}
            color="#444"  // color="text.secondary"
          >
            {post?.frontmatter?.description}
          </Typography>
          <Box component="div" sx={{ position: "relative" }}>
            <Typography
              variant="body1"
              gutterBottom
              component="div"
              // className={more ? '' : `postContent`}
              sx={{
                mb: 1, fontWeight: 500, color: 'text.description', fontSize: '.95rem', '& ul': { paddingInlineStart: "17px", mt: 1 }
                // display: '-webkit-box', WebkitLineClamp: more ? 0 : 20, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis'
              }}
              dangerouslySetInnerHTML={{
                __html: `
                    ${post?.frontmatter?.new ?
                    `<div style="margin: 0; font-weight: 400;font-size: 1rem; line-height: 1.5;letter-spacing: 0.00938em;
                      margin-bottom: 0.35em;color: #174ea6;margin-right: 16px;margin-top: 16px;white-space: nowrap;"
                    >
                      What's new:
                    </div>
                      ${post?.frontmatter?.new}` : ``}
                    ${post?.frontmatter?.performance ?
                    `<div style="margin: 0; font-weight: 400;font-size: 1rem; line-height: 1.5;letter-spacing: 0.00938em;
                      margin-bottom: 0.35em;color: #174ea6;margin-right: 16px;margin-top: 16px;white-space: nowrap;"
                    >
                      Performance so Far:
                    </div>
                      ${post?.frontmatter?.performance}` : ``}`
              }}
            />
            {/* <Box sx={{ zIndex: 9, width: '100%', textAlign: 'center', position: 'absolute', bottom: -27 }} >
                  <Button className="view-more-btn" variant="text" fontSize="small"
                    onClick={() => setMore(!more)}
                    sx={{ textTransform: 'none', color: '#3E5060', fontSize: '.875rem', '&:hover': { color: '#174ea6', } }} startIcon={more ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}>
                    {more ? `View Less` : `View More`}
                  </Button>
                </Box> */}
          </Box>
          {/* <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
            {post?.frontmatter?.tags?.map(d =>
              d && d === 'premium' ?
                <Chip key={getRandomStr(3)} label={d} size="small" sx={{ background: 'linear-gradient(to right, #2DA1EE, #174ea6)', color: '#fff', textTransform: 'capitalize' }} /> :
                <Chip key={getRandomStr(3)} label={d.replace(/-/g, " ")} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', textTransform: 'capitalize' }} />)}
            {(index == 0 || index == 1) && !post?.frontmatter?.tags?.find(d => d === 'latest') && <Chip label={`Latest`} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', }} />}
          </Stack> */}
        </CardContent>
      </StyledCard>
      {/* </Grid> */}
    </>
  )
}
